/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=69ffc2c8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=69ffc2c8&lang=less&scoped=true"

import exportComponent from "/Users/zhangheng/Desktop/development/officialwebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69ffc2c8"]])

export default __exports__